import React from "react";
import { getAppUrl } from "@webcore/config/appConfig.ts";
import DatafabriqLogo from "./DatafabriqLogo";
import ContentButton from "./ui/ContentButton";

export interface ContentNavLink {
  label: string;
  to: string;
}

interface ContentNavProps {
  navLinks?: ContentNavLink[];
  showSignInButtons?: boolean;
  signUpEnabled?: boolean;
}

const ContentNav: React.FC<ContentNavProps> = ({
  navLinks = [],
  showSignInButtons = true,
  signUpEnabled = false,
}) => {
  return (
    <nav className="cs-nav">
      <div className="cs-nav-inner">
        <DatafabriqLogo />

        {navLinks.length > 0 && (
          <div className="cs-nav-mid">
            {navLinks.map((link) => (
              <a key={link.to} href={link.to}>{link.label}</a>
            ))}
          </div>
        )}

        <div className="cs-nav-right">
          {showSignInButtons && (
            <>
              <ContentButton href={getAppUrl("/login/start")} variant="secondary">
                sign in
              </ContentButton>
              {signUpEnabled && (
                <ContentButton
                  href="https://calendar.app.google/rQuDdWM57HswfdSB9"
                  variant="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  request access →
                </ContentButton>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default ContentNav;
